import { formatDistanceToNow } from 'date-fns';
import { Text } from '@optiaxiom/react';

type TimestampCellProps = {
  timestamp: string;
};

const formatTimestamp = (timestamp: string) => {
  const utcTimestamp = timestamp.endsWith('Z') ? timestamp : timestamp + 'Z';
  const date = new Date(utcTimestamp);
  return formatDistanceToNow(date, { addSuffix: true });
};

const formatFullTimestamp = (timestamp: string) => {
  const utcTimestamp = timestamp.endsWith('Z') ? timestamp : timestamp + 'Z';
  const date = new Date(utcTimestamp);

  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
  });
};

export function TimestampCell({ timestamp }: TimestampCellProps) {
  return (
    <Text fontSize="md" title={formatFullTimestamp(timestamp)}>
      {formatTimestamp(timestamp)}
    </Text>
  );
}
